import React, { useState } from 'react';
import {NeuroMessage, useProduct, IgniteCommonActions} from "@ignitesales/neuro-application";
import {Modal} from "@ignitesales/neuro-application/src/neuro-ui";

const ModernProduct = ({ description, name, product, productUrl, renderProductDisclosuresFn, renderProductFeaturesFn, productActionsRender }) => {
    const { onProductActionClick } = useProduct(product);
    const componentClass = 'product';
    const [ showModal, setShowModal ] = useState(false);

    const renderModal = () => {
        onProductActionClick(IgniteCommonActions.PRODUCT_DETAILS_CLICKED);

        const header = <div className={`${componentClass}__details-header`}>
            <NeuroMessage id="product.seeDetails.header" tagName="span"/>
            <a href={productUrl} target="_blank"><h3>{ name }</h3></a>
        </div>;

        return <Modal
            className={`${componentClass}__modal`}
            show={showModal}
            onClose={() => setShowModal(false)}
            title={header}
            nodeId="root"
        >
            <div className={`${componentClass}__modal-info`}>
                <div className={`${componentClass}__description`}>{ description }</div>
                { renderProductFeaturesFn() }
                { renderProductDisclosuresFn() }
            </div>
        </Modal>;
    };

    return <div className={componentClass}>
        <div className={`${componentClass}__title`}>
            <a href={productUrl} target="_blank"><h4>{ name }</h4></a>
        </div>
        <div className={`${componentClass}__description`}>{ description }</div>
        <div className={`${componentClass}__moreDetails`}>
            <span onClick={() => setShowModal(true)}>
                <NeuroMessage id='product.seeDetails' />
            </span>
        </div>
        { productActionsRender }
        { showModal ? renderModal() : null }
    </div>;
};

export default ModernProduct;
